import KformComponent from '../kform-component';
import { createComponentInstance } from '../kform-component-class';
import Card from '~/scripts/services/model/card';

export default class DatagridComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentDatagrid | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.bordered = settings?.bordered ?? false;
		this.components = settings?.components
			? settings.components.map((/** @type {any} */ c) => createComponentInstance(c))
			: [];
		this.disabled = settings?.disabled ?? false;
		this.input = true;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.protected = settings?.protected ?? false;
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom,
			customMessage: settings?.validate?.customMessage,
		};
	}
}
